/* Bucket PDP hero
   "Buckets in your cart" mirrors the real Shopify cart: every change goes through the Cart AJAX API
   and the section re-reads /cart.js afterwards, so it never shows anything that isn't in the cart. */
(function () {
  'use strict';

  function init(root) {
    if (!root || root.dataset.bphReady) return;
    var dataEl = root.querySelector('[data-bph-data]');
    if (!dataEl) return;
    root.dataset.bphReady = '1';

    var D = JSON.parse(dataEl.textContent);
    var S = D.strings;
    var ADDED_MS = 3000;

    /* ---------- Products ---------- */
    var products = {};      // product id -> product data
    var variantIndex = {};  // variant id -> { product, variant }
    [D.main].concat(D.cross).forEach(function (p) {
      p.colours = [];
      p.variants.forEach(function (v) {
        variantIndex[v.id] = { product: p, variant: v };
        if (p.colours.indexOf(v.colour) === -1) p.colours.push(v.colour);
      });
      // Keep the order of the colour option values
      var order = Object.keys(p.swatches || {});
      p.colours.sort(function (a, b) { return order.indexOf(a) - order.indexOf(b); });
      products[p.id] = p;
    });
    var MAIN = D.main;

    function variantFor(p, colour) {
      var list = p.variants.filter(function (v) { return v.colour === colour; });
      return list.filter(function (v) { return v.available; })[0] || list[0];
    }
    function firstAvailableColour(p) {
      var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
      return v.colour;
    }

    /* ---------- State ---------- */
    var fromUrl = /[?&]variant=/.test(location.search) && variantIndex[MAIN.selectedVariant];
    var sel = fromUrl ? variantIndex[MAIN.selectedVariant].variant.colour : null;
    if (!sel && MAIN.defaultColour) {
      var wanted = MAIN.colours.filter(function (c) { return c.toLowerCase() === MAIN.defaultColour.toLowerCase(); })[0];
      if (wanted && variantFor(MAIN, wanted).available) sel = wanted;
    }
    if (!sel) sel = variantIndex[MAIN.selectedVariant] ? variantIndex[MAIN.selectedVariant].variant.colour : firstAvailableColour(MAIN);

    var crossSel = {};
    D.cross.forEach(function (p) { crossSel[p.id] = firstAvailableColour(p); });

    var pick = 1;
    var cart = null;
    var justAdded = false;
    var addedTimer;
    var queue = Promise.resolve();

    /* ---------- Helpers ---------- */
    function all(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
    function el(tag, cls, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      if (text != null) n.textContent = text;
      return n;
    }
    function button(cls, text, label) {
      var b = el('button', cls, text);
      b.type = 'button';
      if (label) b.setAttribute('aria-label', label);
      return b;
    }

    var fmt;
    function money(cents) {
      var currency = (cart && cart.currency) || D.currency;
      if (!fmt || fmt.currency !== currency) {
        try {
          fmt = new Intl.NumberFormat(D.locale || undefined, { style: 'currency', currency: currency, currencyDisplay: 'narrowSymbol' });
        } catch (e) {
          fmt = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency });
        }
        fmt.currency = currency;
      }
      return fmt.format(cents / 100);
    }

    // Swatch colour: Shopify swatch first, then the colour name if it's a valid CSS colour.
    var probe = document.createElement('span');
    var colourCache = {};
    function swatchColour(p, name) {
      var c = p.swatches && p.swatches[name];
      if (c) return c;
      var css = String(name).toLowerCase().replace(/\s+/g, '');
      return (window.CSS && CSS.supports('color', css)) ? css : '#555';
    }
    function inkFor(colour) {
      if (colourCache[colour]) return colourCache[colour];
      probe.style.color = colour;
      document.body.appendChild(probe);
      var rgb = (getComputedStyle(probe).color.match(/\d+(\.\d+)?/g) || [0, 0, 0]).map(Number);
      probe.remove();
      var lum = (0.299 * rgb[0] + 0.587 * rgb[1] + 0.114 * rgb[2]) / 255;
      return (colourCache[colour] = lum > 0.6 ? '#000' : '#fff');
    }
    function plural(n) { return n + ' ' + (n === 1 ? S.unit : S.units); }

    /* ---------- Cart API ---------- */
    function api(url, body) {
      return fetch(url, {
        method: body ? 'POST' : 'GET',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-BPH': '1' }, // marks our own requests
        body: body ? JSON.stringify(body) : undefined
      }).then(function (r) {
        return r.json().then(function (j) {
          if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
          return j;
        });
      });
    }
    var lastCount = null;
    function refresh() {
      return api(D.routes.cart).then(function (c) {
        cart = c;
        if (lastCount !== null && c.item_count !== lastCount) updateCartIcon(c.item_count);
        lastCount = c.item_count;
        render();
      }).catch(function () {});
    }
    // Shopify only redraws the header cart count on a page load, so redraw it after every change.
    // Uses the theme's own "cart-icon-bubble" section; falls back to setting the number directly.
    function updateCartIcon(count) {
      var icons = document.querySelectorAll('#cart-icon-bubble');
      if (!icons.length) return;
      var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      fetch(root + '?sections=cart-icon-bubble', { headers: { 'X-BPH': '1' } })
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var html = j && j['cart-icon-bubble'];
          if (!html) throw new Error('no section');
          var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section');
          if (!fresh) throw new Error('no section');
          Array.prototype.forEach.call(icons, function (icon) { icon.innerHTML = fresh.innerHTML; });
        })
        .catch(function () {
          Array.prototype.forEach.call(icons, function (icon) {
            var bubble = icon.querySelector('.cart-count-bubble');
            if (!count) { if (bubble) bubble.remove(); return; }
            if (!bubble) {
              bubble = document.createElement('div');
              bubble.className = 'cart-count-bubble';
              icon.appendChild(bubble);
            }
            bubble.innerHTML = '<span aria-hidden="true">' + (count < 100 ? count : '') + '</span><span class="visually-hidden">' + count + ' items</span>';
          });
        });
    }
    function notifyCartApp() {
      try {
        if (typeof window.unicornRefreshCart === 'function') window.unicornRefreshCart();
      } catch (e) { /* the cart app is optional */ }
      document.dispatchEvent(new CustomEvent('bucket-pdp-hero:cart-changed', { bubbles: true }));
    }
    // Run cart changes one at a time so quick taps can't race each other.
    function mutate(fn) {
      root.setAttribute('aria-busy', 'true');
      showError('');
      queue = queue.then(fn).then(function () {
        notifyCartApp();
      }).catch(function (err) {
        showError(err.message);
      }).then(refresh).then(function () {
        root.removeAttribute('aria-busy');
      });
      return queue;
    }
    function addVariant(id, quantity) {
      return mutate(function () { return api(D.routes.add, { items: [{ id: id, quantity: quantity }] }); }).then(function () {
        return !root.querySelector('[data-error]:not([hidden])'); // true when the add worked
      });
    }
    // The sticky "Shop Buckets" button turns green "Added ✓" for a moment after any add to cart.
    var stickyTimer;
    function flashSticky() {
      var shop = root.querySelector('[data-st-shop]');
      if (!shop) return;
      if (!shop.dataset.label) shop.dataset.label = shop.textContent;
      shop.textContent = S.added;
      shop.classList.add('is-added');
      clearTimeout(stickyTimer);
      stickyTimer = setTimeout(unflashSticky, ADDED_MS);
    }
    function unflashSticky() {
      var shop = root.querySelector('[data-st-shop]');
      clearTimeout(stickyTimer);
      if (!shop || !shop.dataset.label) return;
      shop.textContent = shop.dataset.label;
      shop.classList.remove('is-added');
    }
    function setLine(key, quantity) { return mutate(function () { return api(D.routes.change, { id: key, quantity: Math.max(0, quantity) }); }); }

    function showError(msg) {
      all('[data-error]').forEach(function (n) { n.textContent = msg; n.hidden = !msg; });
    }

    /* ---------- Totals ---------- */
    function totals() {
      var lines = cart ? cart.items.filter(function (i) { return products[i.product_id]; }) : [];
      var count = 0, orig = 0, final = 0;
      lines.forEach(function (i) { count += i.quantity; orig += i.original_line_price; final += i.final_line_price; });
      var tier = null, next = null;
      D.tiers.forEach(function (t) {
        if (count >= t.min) tier = t;
        else if (!next) next = t;
      });
      var saving = orig - final;
      // No real discount on the lines yet (e.g. cart not refreshed by the discount): estimate it from the tier.
      if (saving <= 0 && tier) saving = Math.round(orig * tier.pct / 100);
      return { lines: lines, count: count, orig: orig, saving: Math.max(0, saving), tier: tier, next: next };
    }

    /* ---------- Gallery ---------- */
    var slides = root.querySelector('[data-slides]');
    var thumbs = all('[data-thumb]');
    function slideIndexFor(mediaId) {
      var list = all('[data-media-id]');
      for (var i = 0; i < list.length; i++) if (String(list[i].dataset.mediaId) === String(mediaId)) return i;
      return -1;
    }
    function goToSlide(i) {
      if (!slides || i < 0) return;
      slides.scrollTo({ left: i * slides.clientWidth, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    }
    // Endless gallery: arrows wrap around (last -> first, first -> last), and so does
    // swiping past the last / first slide.
    var slidePrev = root.querySelector('[data-slides-prev]');
    var slideNext = root.querySelector('[data-slides-next]');
    function currentSlide() { return slides.clientWidth ? Math.round(slides.scrollLeft / slides.clientWidth) : 0; }
    function stepSlide(dir) {
      var last = slides.children.length - 1;
      var i = currentSlide() + dir;
      goToSlide(i > last ? 0 : i < 0 ? last : i);
    }
    if (slides && slides.children.length > 1) {
      if (slidePrev && slideNext) {
        slidePrev.hidden = slideNext.hidden = false;
        slidePrev.addEventListener('click', function () { stepSlide(-1); });
        slideNext.addEventListener('click', function () { stepSlide(1); });
      }
      // A swipe that starts on the last slide and keeps going left (or the first slide, going right)
      // can't scroll any further, so wrap round instead.
      var touchX = null, touchY = 0, touchFrom = 0;
      slides.addEventListener('touchstart', function (e) {
        touchX = e.touches[0].clientX; touchY = e.touches[0].clientY; touchFrom = currentSlide();
      }, { passive: true });
      slides.addEventListener('touchend', function (e) {
        if (touchX === null) return;
        var dx = e.changedTouches[0].clientX - touchX;
        var dy = e.changedTouches[0].clientY - touchY;
        var last = slides.children.length - 1;
        touchX = null;
        if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return; // not a sideways swipe
        if (dx < 0 && touchFrom === last && currentSlide() === last) goToSlide(0);
        else if (dx > 0 && touchFrom === 0 && currentSlide() === 0) goToSlide(last);
      }, { passive: true });
    }
    if (slides) {
      var ticking = false;
      slides.addEventListener('scroll', function () {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(function () {
          ticking = false;
          var i = currentSlide();
          thumbs.forEach(function (t, n) {
            t.classList.toggle('is-active', n === i);
            if (n === i) t.setAttribute('aria-current', 'true'); else t.removeAttribute('aria-current');
          });
        });
      }, { passive: true });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('click', function (e) {
        e.preventDefault();
        goToSlide(slideIndexFor(t.dataset.thumb));
      });
    });

    /* Gallery videos: play muted while their slide is on screen, pause otherwise; pause button.
       Visitors who prefer reduced motion see the cover until they press play. */
    var reduceGallery = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    all('video.bph__video').forEach(function (video) {
      var btn = video.parentNode.querySelector('[data-bph-vbtn]');
      var userPaused = reduceGallery;
      function sync() {
        if (!btn) return;
        btn.hidden = false;
        btn.classList.toggle('is-paused', video.paused);
        btn.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
      }
      function play() { var pr = video.play(); if (pr && pr.catch) pr.catch(sync); }
      video.muted = true;
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      if (btn) btn.addEventListener('click', function () {
        userPaused = !video.paused;
        if (userPaused) video.pause(); else play();
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          var on = entries[0].intersectionRatio >= 0.6;
          if (on && !userPaused) play();
          else if (!on && !video.paused) video.pause();
        }, { threshold: [0, 0.6, 1] }).observe(video);
      }
      sync();
    });
    all('[data-bph-ext]').forEach(function (b) {
      b.addEventListener('click', function () {
        var frame = document.createElement('iframe');
        frame.src = b.dataset.bphExt;
        frame.title = 'Product video';
        frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
        frame.setAttribute('allowfullscreen', '');
        b.replaceWith(frame);
      });
    });

    /* ---------- Swatches ---------- */
    var swatchBox = root.querySelector('[data-swatches]');
    var swatchButtons = {};
    // Show swatches whenever the product has a real colour, even just one (e.g. square buckets: Black).
    // Only products with no colour at all ("Default") hide them.
    var hasSwatches = MAIN.colours.length > 1 || (MAIN.colours.length === 1 && MAIN.colours[0] !== 'Default');
    if (swatchBox) {
      if (!hasSwatches) swatchBox.closest('.bph__colour').classList.add('is-single');
      MAIN.colours.forEach(function (c) {
        var v = variantFor(MAIN, c);
        var b = button('bph__sw', null, c + (v.available ? '' : ' (sold out)'));
        var dot = el('span', 'bph__sw-dot');
        var col = swatchColour(MAIN, c);
        if (/^(https?:)?\/\//.test(col)) dot.style.backgroundImage = 'url("' + col + '")';
        else dot.style.setProperty('--sw', col);
        b.appendChild(dot);
        b.appendChild(el('span', 'bph__sw-name', c));
        if (!v.available) b.classList.add('is-soldout');
        b.addEventListener('click', function () { selectColour(c); });
        swatchBox.appendChild(b);
        swatchButtons[c] = b;
      });
      if (!hasSwatches) swatchBox.hidden = true;
    }
    function selectColour(c) {
      sel = c;
      var v = variantFor(MAIN, c);
      if (v.media) goToSlide(slideIndexFor(v.media));
      try {
        var url = new URL(location.href);
        url.searchParams.set('variant', v.id);
        history.replaceState(history.state, '', url.toString());
      } catch (e) { /* not critical */ }
      preload(v.image || MAIN.image);
      render();
    }

    /* ---------- Quantity stepper ---------- */
    // Quantity can also be typed (1-99). Applies on every keystroke; tidies up when the field is left.
    all('[data-pick]').forEach(function (input) {
      function read(final) {
        var n = parseInt(input.value, 10);
        if (isNaN(n)) { if (final) input.value = pick; return; }
        pick = Math.min(99, Math.max(1, n));
        if (final || n !== pick) input.value = pick;
        render();
      }
      input.addEventListener('input', function () { read(false); });
      input.addEventListener('change', function () { read(true); });
      input.addEventListener('blur', function () { read(true); });
      input.addEventListener('focus', function () { input.select(); });
      input.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { e.preventDefault(); read(true); input.blur(); }
      });
    });
    all('[data-step]').forEach(function (b) {
      if (b.closest('[data-card]')) return;
      b.addEventListener('click', function () {
        pick = Math.min(99, Math.max(1, pick + Number(b.dataset.step)));
        render();
      });
    });

    /* ---------- Add to cart (main + sticky) ---------- */
    all('[data-cta]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = variantFor(MAIN, sel);
        if (!v) return;
        if (!v.available) { openNotify(MAIN, v); return; }
        var n = pick;
        throwToCart(b, v.image || MAIN.image, n);
        // Show "Added ✓" straight away. The cart (and the cart drawer app) can take a few
        // seconds to answer; if the add fails, the button goes back and the error shows.
        pick = 1;
        justAdded = true;
        clearTimeout(addedTimer);
        addedTimer = setTimeout(function () { justAdded = false; render(); }, ADDED_MS);
        render();
        flashSticky();
        addVariant(v.id, n).then(function (ok) {
          if (ok) return;
          justAdded = false;
          clearTimeout(addedTimer);
          pick = n;
          unflashSticky();
          render();
        });
      });
    });

    /* ---------- Clear ---------- */
    // Reads the cart fresh first (the cart drawer app or a double tap can change it), then
    // removes every bucket line. If Shopify rejects the batch, it removes them one by one.
    var clearing = false;
    all('[data-clear]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (clearing) return;
        clearing = true;
        mutate(function () {
          return api(D.routes.cart).then(function (fresh) {
            var lines = fresh.items.filter(function (i) { return products[i.product_id]; });
            if (!lines.length) return;
            var updates = {};
            lines.forEach(function (l) { updates[l.key] = 0; });
            return api(D.routes.update, { updates: updates }).catch(function () {
              return lines.reduce(function (p, l) {
                return p.then(function () {
                  return api(D.routes.change, { id: l.key, quantity: 0 }).catch(function () {});
                });
              }, Promise.resolve());
            });
          });
        }).then(function () { clearing = false; });
      });
    });

    /* ---------- View cart ---------- */
    all('[data-view-cart]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (typeof window.unicornOpenCart === 'function') {
          e.preventDefault();
          try { window.unicornRefreshCart && window.unicornRefreshCart(); } catch (err) { /* optional */ }
          window.unicornOpenCart();
        }
      });
    });

    /* ---------- Token −/+ (event delegation) ---------- */
    root.addEventListener('click', function (e) {
      var b = e.target.closest('[data-line]');
      if (!b || !root.contains(b)) return;
      var line = cart && cart.items.filter(function (i) { return i.key === b.dataset.line; })[0];
      if (line) setLine(line.key, line.quantity + Number(b.dataset.d));
    });

    /* ---------- Other sizes ---------- */
    var cards = all('[data-card]').map(function (card) {
      var p = products[card.dataset.card];
      var ctl = card.querySelector('[data-card-ctl]');
      if (!p || !ctl) return null;
      var dot, select;
      if (p.colours.length > 1) {
        var dd = el('label', 'bph__dd');
        dot = el('i');
        select = el('select');
        select.setAttribute('aria-label', p.label + ' colour');
        p.colours.forEach(function (c) {
          var o = el('option', null, c + (variantFor(p, c).available ? '' : ' (sold out)'));
          o.value = c;
          select.appendChild(o);
        });
        select.value = crossSel[p.id];
        select.addEventListener('change', function () { crossSel[p.id] = select.value; render(); });
        dd.appendChild(dot);
        dd.appendChild(select);
        ctl.appendChild(dd);
      }
      var slot = el('div', 'bph__card-slot');
      ctl.appendChild(slot);
      return { p: p, dot: dot, slot: slot, img: card.querySelector('.bph__card-product img') };
    }).filter(Boolean);

    // Other sizes row: arrows for mouse users when there are more sizes than fit (desktop CSS shows them).
    (function () {
      var row = root.querySelector('[data-cards]');
      var prev = root.querySelector('[data-cards-prev]');
      var next = root.querySelector('[data-cards-next]');
      if (!row || !prev || !next) return;
      function update() {
        var overflow = row.scrollWidth - row.clientWidth > 2;
        prev.hidden = next.hidden = !overflow;
        prev.disabled = row.scrollLeft <= 2;
        next.disabled = row.scrollLeft >= row.scrollWidth - row.clientWidth - 2;
      }
      function step(dir) {
        var card = row.querySelector('.bph__card');
        row.scrollBy({ left: dir * ((card ? card.offsetWidth : 140) + 8), behavior: reduceMotion.matches ? 'auto' : 'smooth' });
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
      row.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      update();
    })();

    function renderCards() {
      cards.forEach(function (c) {
        var p = c.p, colour = crossSel[p.id], v = variantFor(p, colour);
        if (c.dot) c.dot.style.background = swatchColour(p, colour);
        var line = cart && cart.items.filter(function (i) { return i.variant_id === v.id; })[0];
        var name = p.label + ' ' + (p.type || '') + (p.colours.length > 1 ? ', ' + colour : '');
        c.slot.textContent = '';
        if (line) {
          var step = el('div', 'bph__card-step');
          var minus = button('bph__step', '−', 'Remove one ' + name);
          minus.dataset.line = line.key; minus.dataset.d = '-1';
          var plus = button('bph__step bph__step--plus', '+', 'Add one more ' + name);
          plus.dataset.line = line.key; plus.dataset.d = '1';
          var out = el('output', null, String(line.quantity));
          out.setAttribute('aria-label', line.quantity + ' in cart');
          step.appendChild(minus); step.appendChild(out); step.appendChild(plus);
          c.slot.appendChild(step);
        } else {
          var add = v.available
            ? button('bph__add', '+ Add', 'Add ' + name + ' to cart')
            : button('bph__add bph__add--notify', 'Notify me', 'Get notified when ' + name + ' is back');
          add.addEventListener('click', function () {
            if (!v.available) { openNotify(p, v); return; }
            throwToCart(c.img || add, v.image || p.image, 1);
            flashSticky();
            addVariant(v.id, 1).then(function (ok) { if (!ok) unflashSticky(); });
          });
          add.addEventListener('pointerenter', function () { preload(v.image || p.image); }, { once: true });
          c.slot.appendChild(add);
        }
      });
    }

    /* ---------- Rendering ---------- */
    // Cart box: one circle (square for square buckets) per size and colour, with a ×n badge;
    // quantities change in the slide-out cart ("Edit"), so the box stays compact.
    // Sticky bar (expanded): one row per line with a big stepper; at 1 the minus becomes a bin.
    var BIN = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M9 3h6l1 2h4v2H4V5h4l1-2zM6 9h12l-1 12H7L6 9zm4 2v8h1.5v-8H10zm2.5 0v8H14v-8h-1.5z"/></svg>';
    function renderTokens(t) {
      all('[data-tokens]').forEach(function (list) {
        var rows = !!list.closest('[data-st-more]');
        list.textContent = '';
        t.lines.forEach(function (l) {
          var info = variantIndex[l.variant_id];
          var p = products[l.product_id];
          var colour = info ? info.variant.colour : '';
          var bg = swatchColour(p, colour);
          var name = p.label + ' ' + (p.colours.length > 1 ? colour : (p.type || ''));
          var li = el('li', 'bph__tk' + (rows ? ' bph__tk--row' : '') + (p.shape === 'square' ? ' bph__tk--square' : ''));
          var shape = el('span', 'bph__tk-shape', p.label);
          shape.style.background = bg;
          shape.style.color = inkFor(bg);
          shape.setAttribute('aria-hidden', 'true');
          li.appendChild(shape);
          if (rows) {
            li.appendChild(el('span', 'bph__tk-name', p.colours.length > 1 ? colour : (p.type || p.label)));
            var step = el('span', 'bph__tk-step');
            var last = l.quantity <= 1;
            var minus = button('bph__tk-btn' + (last ? ' bph__tk-btn--remove' : ''), '', (last ? 'Remove ' : 'Remove one ') + name);
            minus.innerHTML = last ? BIN : '<span aria-hidden="true">−</span>';
            minus.dataset.line = l.key; minus.dataset.d = '-1';
            var qty = el('output', 'bph__tk-count', String(l.quantity));
            qty.setAttribute('aria-label', l.quantity + ' × ' + name);
            var plus = button('bph__tk-btn bph__tk-btn--add', '', 'Add one more ' + name);
            plus.innerHTML = '<span aria-hidden="true">+</span>';
            plus.dataset.line = l.key; plus.dataset.d = '1';
            step.appendChild(minus); step.appendChild(qty); step.appendChild(plus);
            li.appendChild(step);
          } else {
            li.title = name;
            if (l.quantity > 1) {
              var q = el('span', 'bph__tk-qty', '×' + l.quantity);
              q.setAttribute('aria-hidden', 'true');
              li.appendChild(q);
            }
            li.appendChild(el('span', 'bph__sr', l.quantity + ' × ' + name));
          }
          list.appendChild(li);
        });
      });
    }

    function renderMessage(t) {
      var first = D.tiers[0];
      all('[data-msg]').forEach(function (n) {
        n.textContent = '';
        if (t.tier) {
          n.appendChild(el('strong', null, t.tier.pct + '% OFF unlocked ✓'));
          n.appendChild(document.createTextNode(t.next
            ? '  ·  Add ' + (t.next.min - t.count) + ' more (any size) for ' + t.next.pct + '% OFF'
            : '  ·  best price'));
        } else if (t.count) {
          n.textContent = 'Add ' + (first.min - t.count) + ' more (any size) to unlock ' + first.pct + '% OFF';
        } else {
          n.appendChild(el('span', 'is-muted', 'Nothing added yet.'));
          n.appendChild(document.createTextNode(' Add ' + first.min + ' (any size) for ' + first.pct + '% OFF'));
        }
      });
    }

    function ctaText() {
      var v = variantFor(MAIN, sel);
      if (!v) return { text: S.soldOut || 'Sold out', disabled: true };
      if (!v.available) return { text: S.notify, disabled: false, notify: true };
      if (justAdded) return { text: S.added, disabled: false };
      return { text: S.cta + ' ⇾', disabled: false };
    }

    function render() {
      var t = totals();
      var v = variantFor(MAIN, sel);

      // Colour + price
      all('[data-colour-name]').forEach(function (n) { n.textContent = hasSwatches ? sel : ''; });
      Object.keys(swatchButtons).forEach(function (c) { swatchButtons[c].setAttribute('aria-pressed', String(c === sel)); });
      all('[data-price]').forEach(function (n) { n.textContent = money(v.price); });

      // Stepper
      all('[data-pick]').forEach(function (n) { if (document.activeElement !== n) n.value = pick; n.disabled = !v.available; });
      all('[data-step="-1"]').forEach(function (b) { if (!b.closest('[data-card]')) b.disabled = pick <= 1 || !v.available; });
      all('[data-step="1"]').forEach(function (b) { if (!b.closest('[data-card]')) b.disabled = !v.available; });

      // Buttons
      var c = ctaText();
      all('[data-cta]').forEach(function (b) {
        b.textContent = c.text;
        b.disabled = c.disabled;
        b.classList.toggle('is-added', justAdded && !c.notify);
        b.classList.toggle('is-notify', !!c.notify);
      });
      all('[data-view-cart]').forEach(function (a) { a.hidden = !t.count; });
      all('[data-saving]').forEach(function (n) {
        var show = t.count >= D.tiers[0].min && t.saving > 0;
        n.hidden = !show;
        n.textContent = show ? S.saving.replace('[amount]', money(t.saving)) : '';
      });

      // Buckets in your cart
      all('[data-bundle-count]').forEach(function (n) { n.textContent = t.count ? '· ' + plural(t.count) : ''; });
      all('[data-clear]').forEach(function (b) { b.hidden = !t.count; });
      var top = D.tiers[D.tiers.length - 1].min;
      all('[data-fill]').forEach(function (n) { n.style.width = Math.min(100, t.count / top * 100) + '%'; });
      renderTokens(t);
      renderMessage(t);
      renderCards();
      renderSticky(t);
    }

    /* ---------- Sticky bar (mobile) ---------- */
    var sticky = root.querySelector('[data-sticky]');
    var MAX_DOTS = 10;
    function renderSticky(t) {
      if (!sticky) return;
      var has = t.count > 0;
      sticky.classList.toggle('has-items', has);
      if (!has) setOpen(false);
      sticky.querySelector('.bph__st-handle').hidden = !has;
      sticky.querySelector('[data-st-count]').textContent = plural(t.count) + ' in cart';

      // One circle (or square) per bucket, coloured like the bucket and labelled with its size.
      var dots = sticky.querySelector('[data-st-dots]');
      dots.textContent = '';
      var units = [];
      t.lines.forEach(function (l) {
        for (var q = 0; q < l.quantity; q++) units.push(l);
      });
      var shown = units.length > MAX_DOTS ? MAX_DOTS - 1 : units.length;
      units.slice(0, shown).forEach(function (l) {
        var info = variantIndex[l.variant_id];
        var p = products[l.product_id];
        var bg = swatchColour(p, info ? info.variant.colour : '');
        var d = el('span', 'bph__st-dot' + (p.shape === 'square' ? ' bph__st-dot--square' : ''), p.label);
        d.style.background = bg;
        d.style.color = inkFor(bg);
        dots.appendChild(d);
      });
      if (units.length > shown) dots.appendChild(el('span', 'bph__st-dot bph__st-dot--more', '+' + (units.length - shown)));

      sticky.querySelector('[data-st-totalrow]').hidden = !has;
      sticky.querySelector('[data-st-total]').textContent = money(t.orig - t.saving);
      var was = sticky.querySelector('[data-st-was]');
      was.hidden = !(has && t.saving > 0);
      was.textContent = money(t.orig);
      var tag = sticky.querySelector('[data-st-tag]');
      tag.hidden = !t.tier;
      tag.textContent = t.tier ? t.tier.pct + '% Off' : '';
      sticky.querySelector('[data-st-checkout]').hidden = !has;

      // Free shipping nudge: whole cart after discounts (bucket lines use the tier estimate until the cart catches up).
      var ship = sticky.querySelector('[data-ship]');
      if (ship) {
        var bucketFinal = t.lines.reduce(function (a, i) { return a + i.final_line_price; }, 0);
        var spend = (cart ? cart.total_price : 0) - bucketFinal + (t.orig - t.saving);
        // The threshold is in the store's currency (AUD); the cart is in the shopper's currency, so convert it.
        var rate = Number(window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
        var left = Number(ship.dataset.threshold) * rate - spend;
        ship.hidden = !has;
        ship.classList.toggle('is-free', left <= 0);
        ship.textContent = '';
        ship.appendChild(document.createTextNode('\uD83D\uDE9A '));
        if (left <= 0) ship.appendChild(el('strong', '', 'Free shipping unlocked!'));
        else {
          ship.appendChild(document.createTextNode('Spend '));
          ship.appendChild(el('strong', '', money(Math.ceil(left / 100) * 100).replace(/[.,]00(?=\D*$)/, '') + ' more'));
          ship.appendChild(document.createTextNode(' for free shipping'));
        }
      }
    }
    function setOpen(open) {
      if (!sticky) return;
      sticky.classList.toggle('is-open', open);
      document.documentElement.classList.toggle('bph-sticky-open', open);
      all('[data-st-toggle]').forEach(function (b) {
        if (b.classList.contains('bph__st-handle')) b.setAttribute('aria-expanded', String(open));
      });
    }
    if (sticky) {
      all('[data-st-toggle]').forEach(function (b) {
        b.addEventListener('click', function () {
          if (sticky.classList.contains('has-items')) setOpen(!sticky.classList.contains('is-open'));
        });
      });
      // "Shop Buckets" scrolls up to the colour picker.
      var shop = sticky.querySelector('[data-st-shop]');
      if (shop) shop.addEventListener('click', function () {
        setOpen(false);
        var target = root.querySelector('.bph__colour') || root;
        target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
        var first = target.querySelector('.bph__sw[aria-pressed="true"]') || target.querySelector('.bph__sw');
        if (first) first.focus({ preventScroll: true });
      });
      // Swipe up on the bar to see the buckets in the cart, swipe down to hide them.
      var startY = null;
      sticky.addEventListener('touchstart', function (e) { startY = e.touches[0].clientY; }, { passive: true });
      sticky.addEventListener('touchend', function (e) {
        if (startY === null || !sticky.classList.contains('has-items')) return;
        var dy = e.changedTouches[0].clientY - startY;
        startY = null;
        if (dy < -30) setOpen(true);
        else if (dy > 30) setOpen(false);
      }, { passive: true });
      var mainCta = root.querySelector('.bph__info [data-cta]');
      if (mainCta && 'IntersectionObserver' in window) {
        // Show the bar unless most of the main button is on screen.
        new IntersectionObserver(function (entries) {
          var show = entries[0].intersectionRatio < 0.75;
          sticky.classList.toggle('is-shown', show);
          if (!show) setOpen(false);
        }, { threshold: [0, 0.75, 1] }).observe(mainCta);
      }
    }

    /* ---------- Add-to-cart throw ----------
       A cut-out of the added bucket is thrown in an arc to the header cart icon, which then bounces.
       Uses the variant's "pdp_hero.cutout" image (falls back to the variant / product image).
       Turned off when the "Cart icon" setting is empty or the visitor prefers reduced motion. */
    var reduceMotion = window.matchMedia ? matchMedia('(prefers-reduced-motion: reduce)') : { matches: false };
    var preloaded = {};
    function preload(url) {
      if (!url || preloaded[url] || !D.cartSelector) return;
      preloaded[url] = new Image();
      preloaded[url].src = url;
    }
    function onScreen(el) {
      var r = el.getBoundingClientRect();
      if (!r.width || !r.height) return false;
      if (r.bottom < 0 || r.right < 0 || r.top > innerHeight || r.left > innerWidth) return false;
      var cs = getComputedStyle(el);
      return cs.visibility !== 'hidden' && cs.display !== 'none' && Number(cs.opacity) > 0;
    }
    function cartIcon() {
      var found = null;
      try {
        Array.prototype.some.call(document.querySelectorAll(D.cartSelector), function (el) {
          if (onScreen(el)) { found = el; return true; }
          return false;
        });
      } catch (e) { /* invalid selector */ }
      return found;
    }
    function bump(el) {
      if (!el || !el.animate) return;
      el.animate(
        [{ transform: 'scale(1)' }, { transform: 'scale(1.3) rotate(-8deg)' }, { transform: 'scale(0.92)' }, { transform: 'scale(1)' }],
        { duration: 450, easing: 'ease-out' }
      );
    }
    function throwToCart(fromEl, imgUrl, count) {
      if (!D.cartSelector || !fromEl) return;
      var icon = cartIcon();
      if (typeof imgUrl !== 'string') imgUrl = '';
      if (reduceMotion.matches || !imgUrl || !document.body.animate) { bump(icon); return; }
      var fr = fromEl.getBoundingClientRect();
      var from = { x: fr.left + fr.width / 2, y: fr.top + fr.height / 2 };
      var to;
      if (icon) {
        var tr = icon.getBoundingClientRect();
        to = { x: tr.left + tr.width / 2, y: tr.top + tr.height / 2 };
      } else {
        to = { x: innerWidth - 32, y: 24 }; // header scrolled away: aim at the top-right corner
      }
      var lift = Math.max(120, Math.abs(to.x - from.x) * 0.3);
      var ctrl = { x: from.x + (to.x - from.x) * 0.3, y: Math.min(from.y, to.y) - lift };
      var half = 46;
      var throws = Math.min(Math.max(count || 1, 1), 3);

      function launch(i) {
        var img = new Image();
        img.className = 'bph-fly';
        img.alt = '';
        img.decoding = 'async';
        img.src = imgUrl;
        document.body.appendChild(img);
        var frames = [];
        var spin = 340 + i * 40;
        for (var k = 0; k <= 30; k++) {
          var t = k / 30, u = 1 - t;
          var x = u * u * from.x + 2 * u * t * ctrl.x + t * t * to.x;
          var y = u * u * from.y + 2 * u * t * ctrl.y + t * t * to.y;
          var scale = t < 0.12 ? 0.7 + 0.5 * (t / 0.12) : 1.2 - 0.95 * ((t - 0.12) / 0.88);
          frames.push({
            transform: 'translate(' + (x - half) + 'px,' + (y - half) + 'px) rotate(' + (-12 + spin * t) + 'deg) scale(' + scale.toFixed(3) + ')',
            opacity: t > 0.9 ? (1 - t) / 0.1 : 1
          });
        }
        var anim = img.animate(frames, { duration: 820, easing: 'cubic-bezier(.35,.1,.55,1)', fill: 'forwards' });
        var done = function () {
          img.remove();
          if (i === throws - 1) bump(icon);
        };
        anim.onfinish = done;
        anim.oncancel = done;
      }
      for (var i = 0; i < throws; i++) (function (n) { setTimeout(function () { launch(n); }, n * 110); })(i);
    }
    preload((variantFor(MAIN, sel) || {}).image);

    /* ---------- Back in stock (STOQ) ----------
       STOQ is set to the Embedded form store-wide, so its form is rendered inside our dialog.
       openInlineForm needs a CSS selector string for the container, not an element. */
    var notifyDialog = root.querySelector('[data-notify-dialog]');
    function whenStoqReady(done, fail) {
      var ready = function () { return window._RestockRocket && (typeof window._RestockRocket.openInlineForm === 'function' || typeof window._RestockRocket.openModal === 'function'); };
      if (ready()) { done(); return; }
      var finished = false, tries = 0;
      var run = function () { if (!finished && ready()) { finished = true; done(); } };
      window.addEventListener('stoq:loaded', run, { once: true });
      (function poll() {
        if (finished) return;
        if (ready()) { run(); return; }
        if (tries++ < 25) setTimeout(poll, 200);
        else { finished = true; fail(); }
      })();
    }
    function openNotify(p, v) {
      if (!notifyDialog || typeof notifyDialog.showModal !== 'function') return;
      var slot = notifyDialog.querySelector('[data-notify-slot]');
      var msg = notifyDialog.querySelector('[data-notify-msg]');
      notifyDialog.querySelector('[data-notify-for]').textContent =
        [p.label, p.type].filter(Boolean).join(' ') + (p.colours.length > 1 ? ' · ' + v.colour : '');
      slot.textContent = '';
      msg.hidden = false;
      msg.textContent = 'Loading…';
      if (!notifyDialog.open) notifyDialog.showModal();
      whenStoqReady(function () {
        var rr = window._RestockRocket;
        msg.hidden = true;
        if (typeof rr.openInlineForm === 'function') {
          try { rr.openInlineForm(p.stoq, String(v.id), undefined, '#' + slot.id, 'beforeend'); return; } catch (e) { /* fall back to the popup */ }
        }
        notifyDialog.close();
        if (typeof rr.openModal === 'function') rr.openModal(p.stoq, String(v.id));
      }, function () {
        msg.hidden = false;
        msg.textContent = "Sorry, the sign-up form couldn't load. Please try again in a moment.";
      });
    }

    /* ---------- Compare link: smooth scroll to the Compare buckets section ---------- */
    all('[data-compare-scroll]').forEach(function (a) {
      var target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) { a.hidden = true; return; }
      a.addEventListener('click', function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'start' });
        // Move keyboard focus there too, so Tab carries on from the comparison table
        if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
        target.focus({ preventScroll: true });
      });
    });

    /* ---------- Size comparison modal ---------- */
    var dialog = root.querySelector('[data-compare]');
    all('[data-compare-open]').forEach(function (b) {
      if (!dialog || typeof dialog.showModal !== 'function') { b.hidden = true; return; }
      b.addEventListener('click', function () { dialog.showModal(); });
    });
    // Close either dialog when the backdrop is tapped
    [dialog, notifyDialog].forEach(function (d) {
      if (!d) return;
      d.addEventListener('click', function (e) {
        if (e.target !== d) return;
        var r = d.getBoundingClientRect();
        var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
        if (!inside) d.close();
      });
    });

    /* ---------- Keep in sync with changes made elsewhere (cart drawer, other tabs) ---------- */
    // The cart drawer app changes the cart with its own requests; re-read the cart after any of them
    // so "Buckets in your cart" and the sticky bar match the drawer (e.g. after clearing it).
    var syncTimer;
    watchCart(function () {
      clearTimeout(syncTimer);
      syncTimer = setTimeout(refresh, 250);
    });
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart-update'].forEach(function (name) {
      document.addEventListener(name, function () { clearTimeout(syncTimer); syncTimer = setTimeout(refresh, 250); });
    });
    document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') refresh(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

    render();
    refresh();
  }

  /* Calls every listener after any cart change request made on the page by something other than
     this section (fetch or XMLHttpRequest to /cart/add, /cart/change, /cart/update or /cart/clear). */
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  function watchCart(listener) {
    var w = window.__bphCartWatch;
    if (!w) {
      w = window.__bphCartWatch = { listeners: [] };
      var notify = function () { w.listeners.forEach(function (fn) { try { fn(); } catch (e) { /* ignore */ } }); };
      if (window.fetch) {
        var origFetch = window.fetch;
        window.fetch = function (input, opts) {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          var headers = (opts && opts.headers) || {};
          var ours = (headers.get ? headers.get('X-BPH') : headers['X-BPH']) === '1';
          var req = origFetch.apply(this, arguments);
          if (!ours && CART_CHANGE.test(String(url))) req.then(notify, notify);
          return req;
        };
      }
      var origOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url) {
        if (CART_CHANGE.test(String(url))) this.addEventListener('loadend', notify);
        return origOpen.apply(this, arguments);
      };
    }
    w.listeners.push(listener);
  }

  function initAll(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-bph]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
